import React, { useState } from "react"
import { Link } from "react-router-dom"
import configure from "configure"
import moment from "moment"
import indiaFlag from "../../../assets/images/flags/india.png"
import usaFlag from "../../../assets/images/flags/usa.png"
import ukFlag from "../../../assets/images/flags/uk.png"
import candFlag from "../../../assets/images/flags/canadian_flag.jpg"
import CopyToClipboard from "react-copy-to-clipboard"
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap"

const flags = {
  1: indiaFlag,
  2: ukFlag,
  3: usaFlag,
  4: candFlag,
};

export const TenderColumns = (onDelete) => [
  {
    Header: "Sr. No",
    accessor: "id",
    className: "text-center",
  },
  {
    Header: "Date",
    accessor: "apply_date",
    Cell: ({ row: { original } }) =>
      moment(original.apply_date).format("DD-MM-YYYY"),
  },
  {
    Header: "Tender's Name",
    accessor: "name",
    Cell: ({ row }) => {

      return (
        <div>
          <img
            src={flags[Number(row?.original?.location) || 1]}
            className="location-img me-3"
            alt="flag"
          />
          {row?.original?.name}
        </div>
      )
    }
  },
  {
    Header: "Company Name",
    accessor: "company_name",
    Cell: ({ row }) =>
    (
      <div>{row?.original?.company_name || row?.original?.contact_name}</div>
    )
  },
  {
    Header: "Submission Date",
    accessor: "tender_submittion_date",
    Cell: ({ row: { original } }) =>
      moment(original.tender_submittion_date).format("DD-MM-YYYY"),
  },
  {
    Header: "Budget",
    accessor: "budget",
    Cell: ({ row }) =>
    (
      <div>{row?.original?.currency_symbol}{row?.original?.budget}</div>
    )
  },
  {
    Header: "Status",
    accessor: "status",
    className: "text-capitalize"
  },
  {
    Header: "Action",
    accessor: "action",
    Cell: cellProps => (
      <div>
        <Link
          to={`${configure.appUrl}marketing/edit-tender/${cellProps.row.original.id}`}
          title="Edit"
          className="btn btn-sm me-1 btn-outline-secondary"
        >
          <i className="fas fa-pencil-alt"></i>
        </Link>
        <button
          onClick={() => onDelete(cellProps.row.original.id)}
          title="Delete"
          className="btn btn-sm btn-danger"
        >
          <i className="fas fa-trash-alt"></i>
        </button>
      </div>
    ),
  },
]
export const TenderSourceColumns = (onEdit, onDelete) => [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Site Name",
    accessor: "name",
    isInfoIcon: true,
  },
  {
    Header: "URL",
    accessor: "url",
    isInfoIcon: true,
  },
  {
    Header: "Action",
    accessor: "action",
    Cell: ({ row }) => (
      <div>
        <button
          onClick={() =>
            onEdit(row.original.id, row.original.name, row.original.url)
          }
          className="btn action-btn btn-sm me-1 btn-outline-secondary"
        >
          <i className="fas fa-pencil-alt"></i>
        </button>
        <button
          onClick={() => onDelete(row.original.id)}
          className="btn btn-sm action-btn btn-danger"
        >
          <i className="fas fa-trash-alt"></i>
        </button>
      </div>
    ),
  },
]
export const TenderDocumentColumns = (tog_edit, handleDelete) => [
  {
    Header: "ID",
    Cell: ({ row }) => row.index + 1,
  },
  {
    Header: "Name",
    accessor: "documentName",
    isInfoIcon: true,
  },
  {
    Header: "Attachment",
    accessor: "document",
    Cell: ({ value }) =>
      value ? (
        <a href={value} target="_blank" rel="noopener noreferrer">
          View Document
        </a>
      ) : (
        <span>No Attachment</span>
      ),
  },
  {
    Header: "Action",
    accessor: "action",
    Cell: ({ row }) => (
      <div>
        <button
          onClick={() => tog_edit(row.original)}
          className="btn action-btn btn-sm me-1 btn-outline-secondary"
        >
          <i className="fas fa-pencil-alt"></i>
        </button>
        <button
          onClick={e => handleDelete(e, row.original.id)}
          className="btn btn-sm action-btn btn-danger"
        >
          <i className="fas fa-trash-alt"></i>
        </button>
      </div>
    ),
  },
]

export const BiddingColumns = (onDelete) => [
  {
    Header: "Sr. No",
    accessor: "id",
    className: "text-center",
  },
  {
    Header: "Date",
    accessor: "apply_date",
    Cell: ({ row: { original } }) =>
      moment(original.apply_date).format("DD-MM-YYYY"),
  },
  {
    Header: "Bidding's Name",
    accessor: "name",
    Cell: ({ row }) => {
      return (
        <div>
          <img
            src={flags[Number(row?.original?.location) || 1]}
            className="location-img me-3"
            alt="flag"
          />
          {row?.original?.name}
        </div>
      );
    },
  },
  {
    Header: "Company Name",
    accessor: "company_name",
    Cell: ({ row }) => (
      <div>{row?.original?.company_name || row?.original?.contact_name}</div>
    ),
  },
  {
    Header: "Submission Date",
    accessor: "tender_submittion_date",
    Cell: ({ row: { original } }) =>
      moment(original.tender_submittion_date).format("DD-MM-YYYY"),
  },
  {
    Header: "Budget",
    accessor: "budget",
    Cell: ({ row }) => (
      <div>
        {row?.original?.currency_symbol}
        {row?.original?.budget}
      </div>
    ),
  },
  {
    Header: "Status",
    accessor: "status",
    className: "text-capitalize",
  },
  {
    Header: "Action",
    accessor: "action",
    Cell: (cellProps) => {
      const [copy, setCopy] = useState("")
      function copyToClipBoard(e) {
        setCopy("Copied ! ...")
        setTimeout(() => {
          setCopy("")
        }, 1000)
      }
      return (
        <div className="d-flex">
          <UncontrolledDropdown
            className="dropdown "
            style={{ width: "29px" }}
          >
            <DropdownToggle
              className="btn btn-sm btn-outline-secondary w-100 "
              color="white"
            >
              <i className="mdi mdi-dots-horizontal"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <CopyToClipboard
                text={`${cellProps.row.original.project_duration}`}
                onCopy={copyToClipBoard}
              >
                <button
                  className="dropdown-item copyBtn"
                >
                  <i className="fas fa-copy pr-10"></i>
                  {copy?.length == 0 ? "Copy Link" : copy}
                </button>
              </CopyToClipboard>

              <a
                title="delete"
                className="dropdown-item"
                href={cellProps.row.original.project_duration}
                rel="noopener noreferrer"
                target="_blank"
              >
                <i className="fas fa-link text-primary pr-10"></i>{" "}
                Open Link
              </a>
            </DropdownMenu>
          </UncontrolledDropdown>
          <Link
            to={`${configure.appUrl}marketing/edit-bidding/${cellProps.row.original.id}`}
            title="Edit"
            className="btn btn-sm ms-1 me-1 btn-outline-secondary"
          >
            <i className="fas fa-pencil-alt"></i>
          </Link>
          <button
            onClick={() => onDelete(cellProps.row.original.id)}
            title="Delete"
            className="btn btn-sm btn-danger"
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </div>
      )
    }
  },
];
export const BiddingDocumentColumns = (tog_edit, handleDelete) => [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Name",
    accessor: "documentName",
    isInfoIcon: true,
  },
  {
    Header: "Attachment",
    accessor: "document",
    Cell: ({ row }) => {
      return (
        <>
          {row?.original?.document ? (
            <a href={`${row?.original?.document}`} target="_blank" rel="noopener noreferrer">
              View Document
            </a>
          ) : (
            <span>No Attachment</span>
          )
          }
        </>
      )
    }
  },
  {
    Header: "Action",
    accessor: "action",
    Cell: ({ row }) => (
      <div>
        <button
          onClick={() => tog_edit(row.original)}
          className="btn action-btn btn-sm me-1 btn-outline-secondary"
        >
          <i className="fas fa-pencil-alt"></i>
        </button>
        <Link
          onClick={(e) => handleDelete(e, row.original.id)}
          className="btn btn-sm action-btn btn-danger"
        >
          <i className="fas fa-trash-alt"></i>
        </Link>
      </div>
    ),
  },
];
export const BiddingSourceColumns = (openEditModal, handleDelete) => [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Site Name",
    accessor: "name",
    isInfoIcon: true,
  },
  {
    Header: "URL",
    accessor: "url",
    isInfoIcon: true,
  },
  {
    Header: "Action",
    accessor: "action",
    Cell: (cellProps) => {
      const rowData = cellProps.row.original;
      return (
        <div>
          <button
            onClick={() => openEditModal(rowData)}
            className="btn action-btn btn-sm me-1 btn-outline-secondary"
          >
            <i className="fas fa-pencil-alt"></i>
          </button>
          <button
            onClick={(e) => {
              handleDelete(e, rowData.id);
            }}
            className="btn btn-sm action-btn btn-danger"
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </div>
      );
    },
  },
];